<template>
    <!-- <div :class="path === '/BestYou/nomination/nomination' ? 'pro-layout-old' : 'pro-layout'"> -->
    <div :class="path === '/BestYou/about' ? 'pro-layout-old' : 'pro-layout'">
        <div class="pro-layout-header" v-if="path!=='/home'">
            <slot name="header"></slot>

        </div>
        <div class="pro-layout-body" :style="path==='/home'?'height:100vh':''">
            <slot></slot>
            <slot name="footer"></slot>
        </div>
        <video v-show="videoShow && backShow"
class="fullscreenVideo"
id="bgVid"
src='../../../../assets/img/home/01.mp4'
playsinline=""
autoplay=""
muted=""
loop=""
key="01">
            <!-- <source src="../../../../assets/img/home/02.mp4" type="video/mp4"> -->
        </video>
        <video v-show="!videoShow && backShow"
class="fullscreenVideo"
id="bgVid"
src='../../../../assets/img/home/02.mp4'
playsinline=""
autoplay=""
muted=""
loop=""
key="02">
            <!-- <source src="../../../../assets/img/home/02.mp4" type="video/mp4"> -->
        </video>
    </div>
</template>

<script>
export default {
    name: 'base-layout',
    computed:{
        path(){
            return this.$route.path;
        }
    },
    created(){

        if(this.$route.name == 'about'){
            console.log('this.backShow = true;');
            this.backShow = true;
            this.videoShow = false;
            this.$nextTick(() => {
                setTimeout(() => {
                    this.videoShow = true;
                },12030);
            });
        }else{
            this.backShow = false;
        }

    },
    watch: {
        $route(to, from) {
            console.log(to);
            console.log(from);
            if(to.name == 'about'){
                console.log('this.backShow = true;');
                this.backShow = true;
                this.videoShow = false;
                this.$nextTick(() => {

                    setTimeout(() => {
                        this.videoShow = true;
                    },6000);
                });


            }else{
                console.log('this.backShow = false;');
                this.backShow = false;
            }
        }
    },
    data(){
        return{
            backShow:false,
            videoShow:false,
            video1:require('../../../../assets/img/home/01.mp4'),
            video2:require('../../../../assets/img/home/02.mp4')
        };
    }
};
</script>

<style lang="less" scoped>
@import (reference) '~@/assets/theme/theme.less';
.pro-layout {
    display: flex;
    height: 100vh;
    background-image: url("../../assets/img/bg-light-new.png");
    // background-image: url("../../../../assets/img/home/homeBackImg.png");
    background-color: #f5f7f8;
    background-size: 100%;
    background-repeat: no-repeat;
    min-width: 1024px;
}
.pro-layout-old {
    display: flex;
    height: 100vh;
    background-image: url("../../../../assets/img/home/homeBackImg.png");
    background-size: 100%;
    background-repeat: no-repeat;
    min-width: 1024px;
}
.pro-layout-header {
    display: flex;
}

.fullscreenVideo{
  position: absolute;
  width: 100%;
  height: 118%;
  overflow: hidden;
  object-fit: fill;
  top: 0;
  left: 0;
  z-index: 0;
}

.fullscreenVideo:before{
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  display: block;
  z-index: -1;
  top: 0;
  left: 0;
  background: rgba(25,29,34,.65);
}


</style>
